var _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _path8, _line, _line2, _line3, _line4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentRejectedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 100,
    viewBox: "0 0 119 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1 81.6933C28.5861 77.6218 104.583 78.617 108.069 81.6933C111.556 84.7695 105.978 84.1362 108.069 88.2077C110.161 92.2792 120.619 87.5738 118.528 94.7221C116.436 101.87 55.0805 90.6506 51.5944 92.2792C48.1083 93.9078 55.0805 94.7221 51.5944 97.1651C48.1083 99.608 0 102.051 0 95.5368C0 89.0224 34.8611 91.4646 36.9528 88.2077C39.0444 84.9509 21.6139 85.7648 25.1 81.6933Z",
    fill: "#F1F3F5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.8027,
    y: 81.5391,
    width: 5,
    height: 3,
    rx: 1.5,
    fill: "#F1F3F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9362 58.5319V17H36V58.5319L39.8936 56.7293L43.7872 58.5319L47.6809 56.7293L51.5745 58.5319L55.4681 56.7293C55.4681 56.7293 58.5 58.5319 59.5 62.1055C60 59.1055 63.9043 56.7293 63.9043 56.7293L67.7979 58.5319L71.5667 56.7293L74.9362 58.5319Z",
    fill: "#F1F3F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9362 61.5319V20H41V61.5319L44.8936 59.7293L48.7872 61.5319L52.6809 59.7293L56.5745 61.5319L60.4681 59.7293C60.4681 59.7293 63.5 61.5319 64.5 65.1055C65 62.1055 68.9043 59.7293 68.9043 59.7293L72.7979 61.5319L76.5667 59.7293L79.9362 61.5319Z",
    fill: "white",
    stroke: "#1A1B1D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9523 41.5508L68.3087 41.5508",
    stroke: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4665 46.0937L54.681 41.5512L58.1961 41.5512",
    stroke: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2803 37.7656L53.924 37.7656",
    stroke: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7662 33.2227L67.5516 37.7652L64.0366 37.7652",
    stroke: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 77.9894,
    cy: 20.7872,
    r: 7.78723,
    fill: "white",
    stroke: "#1A1B1D",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.1294 16.6539C78.0683 16.5425 77.9103 16.5425 77.8493 16.6539L74.1161 23.4673C74.0568 23.5755 74.134 23.7086 74.2562 23.7086H81.7225C81.8447 23.7086 81.9219 23.5755 81.8625 23.4673L78.1294 16.6539ZM77.6649 21.3075V19.1661H78.3138V21.3075H77.6649ZM77.9893 22.5405C77.7743 22.5405 77.6 22.3662 77.6 22.1512C77.6 21.9361 77.7743 21.7618 77.9893 21.7618C78.2044 21.7618 78.3787 21.9361 78.3787 22.1512C78.3787 22.3662 78.2044 22.5405 77.9893 22.5405Z",
    fill: "#1A1B1D"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 47.3408,
    y1: 62.3184,
    x2: 47.3408,
    y2: 70.1056,
    stroke: "#1A1B1D"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 75.8936,
    y1: 62.3184,
    x2: 75.8936,
    y2: 70.1056,
    stroke: "#1A1B1D"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 70.7021,
    y1: 68,
    x2: 70.7021,
    y2: 75.7872,
    stroke: "#1A1B1D"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 64.5,
    y1: 66,
    x2: 64.5,
    y2: 68,
    stroke: "#1A1B1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentRejectedIcon);
export default __webpack_public_path__ + "static/media/PaymentRejectedIcon.dd7734a0583ce7475ba47f3f59efc739.svg";
export { ForwardRef as ReactComponent };